/** Dates for office users: `3 Nov 2026`; moments in the browser's local time with the UTC offset. */

export function formatDate(isoDate: string): string {
  const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(y ?? 1970, (m ?? 1) - 1, d ?? 1)).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function utcOffsetLabel(moment: Date): string {
  const minutes = -moment.getTimezoneOffset();
  if (minutes === 0) {
    return 'UTC';
  }
  const sign = minutes > 0 ? '+' : '−';
  const abs = Math.abs(minutes);
  const rest = abs % 60;
  return `UTC${sign}${Math.floor(abs / 60)}${rest === 0 ? '' : `:${String(rest).padStart(2, '0')}`}`;
}

export function formatDateTime(isoTimestamp: string): string {
  const moment = new Date(isoTimestamp);
  const date = moment.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  const time = moment.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${date}, ${time} (${utcOffsetLabel(moment)})`;
}

/** Today's calendar date in the browser (`YYYY-MM-DD`). */
export function today(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
